import config from '@/config'

export default {
  combine: {
    confirm_password: "ยืนยัน @:ui.password",
    change_password: "เปลี่ยน @:ui.password",
    old_password: "เก่า @:ui.password",
    new_password: "@:ui.new @:ui.password",
    confirm_security_code: "ยืนยัน @:ui.security_code",
    first_time_login: "เข้าสู่ระบบครั้งแรก",
    security_authentication: "การรับรองความถูกต้องด้านความปลอดภัย",
    update_security: "อัปเดตความปลอดภัย",
    disable_security: "ปิดการใช้งานการรักษาความปลอดภัย",
    add_account: "เพิ่มบัญชี",
    add_sub_account: "เพิ่มบัญชีย่อย",
    edit_operator: "แก้ไขผู้ดําเนินการ",
    edit_account: "แก้ไขบัญชี",
    edit_member: "แก้ไขสมาชิก",
    approve_ticket: "อนุมัติตั๋ว",
    reject_ticket: "ปฏิเสธตั๋ว",
    add_bank_account: "เพิ่มบัญชีธนาคาร",
    edit_bank_account: "แก้ไขบัญชีธนาคาร",
    reset_threshold: "รีเซ็ตเกณฑ์",
    adjust_balance: "ปรับสมดุล",
    adjust_member: "ปรับสมาชิก",
    configure_bank_setting: "กําหนดค่าการตั้งค่าธนาคาร",
    account_setup: "การตั้งค่าบัญชี",
    bank_transfer: "การโอนเงินผ่านธนาคาร",
    edit_bank_member: "แก้ไขสมาชิกธนาคาร",
    edit_ticket: "แก้ไขตั๋ว",
    edit_vip: "แก้ไขวีไอพี",
    knock_off_promo: "โปรโมชั่นน็อคออฟ",
    edit_authority: "แก้ไขอํานาจ",
    reset_password: "รีเซ็ตรหัสผ่าน",
    update_password: "อัปเดตรหัสผ่าน",
    member_summary: "บทสรุปสมาชิก",
    reply_review: "ตอบกลับรีวิว",
    edit_affiliate: "แก้ไขพันธมิตร",
    edit_bank_affiliate: "แก้ไขพันธมิตรธนาคาร",
    approve_affiliate_ticket: "อนุมัติตั๋วพันธมิตร",
    check_free_spin: "ตรวจสอบการหมุนฟรี",
    reject_affiliate_ticket: "ปฏิเสธตั๋วพันธมิตร",
    wallet_adjust: "ปรับกระเป๋าเงิน",
    update_comm_package: "อัปเดตแพ็คเกจคอมมิชชั่น",
    approve_affiliate: "อนุมัติพันธมิตร",
    sub_acc_detail_affiliate: "บริษัทในเครือรายละเอียดบัญชีย่อย",
    get_tac: "รับ สนข.",
    add_coupon: "เพิ่มคูปอง",
    update_coupon: "อัปเดตคูปอง",
    issue_free_spin: "ออกฟรีสปิน",
    get_bank_tac: "รับ OTP ธนาคาร",
    update_global_setting: "อัปเดตการตั้งค่าทั่วโลก",
    add_platform: "เพิ่มแพลตฟอร์ม",
    edit_platform: "แก้ไขแพลตฟอร์ม",
    add_bank_group: "เพิ่มกลุ่มธนาคาร",
    edit_bank_group: "แก้ไขกลุ่มธนาคาร",
    update_maintenance_schedule: "ปรับปรุงตารางการบํารุงรักษา",
    add_withdrawal_limit: "เพิ่มขีดจํากัดการถอน",
    edit_withdrawal_limit: "แก้ไขขีดจํากัดการถอน",
    add_campaign: "เพิ่มแคมเปญ",
    edit_campaign: "แก้ไขแคมเปญ",
    add_promo_group: "เพิ่มกลุ่มโปรโมชั่น",
    edit_promo_group: "แก้ไขกลุ่มส่งเสริม",
    update_team: "อัพเดททีม",
    update_result: "อัปเดตผลลัพธ์",
    insert_result: "แทรกผลลัพธ์",
    bet_list: "รายการเดิมพัน",
    result_list: "รายการผลลัพธ์",
    add_promo: "เพิ่มโปรโมชั่น",
    raise_deposit_ticket: "ตั๋วเงินฝากเพิ่ม",
    bank_adjust: "ธนาคารปรับ",
    promo_member_assign: "การมอบหมายสมาชิกโปรโมชั่น",
    bonus_issue: "ปัญหาโบนัส",
    update_vip: "อัพเดทวีไอพี",
    update_member_profile: "อัปเดตโปรไฟล์สมาชิก",
    change_withdrawal_limit: "เปลี่ยนขีดจํากัดการถอน",
    change_bank_group: "เปลี่ยนกลุ่มธนาคาร",
    change_promotion_group: "กลุ่มส่งเสริมการเปลี่ยนแปลง",
    edit_promo_signup: "แก้ไขการสมัครโปรโมชั่น",
    update_provider_bet_limit: "อัปเดตขีดจํากัดการเดิมพันของผู้ให้บริการ",
    update_bet_limit: "อัปเดตขีดจํากัดการเดิมพัน",
    update_member_bet_limit: "อัปเดตขีดจํากัดการเดิมพันของสมาชิก",
    edit_bank_account_group: "แก้ไขกลุ่มบัญชีธนาคาร",
    redeposit_ticket: "ตั๋วฝากซ้ํา",
    edit_promotion_group: "แก้ไขกลุ่มส่งเสริม",
    edit_promotion_group_norm: "จัดการการส่งเสริมการขายในกลุ่ม",
    get_inbox_list: "รับรายการกล่องจดหมาย",
    view_result_changes_detail: "ดูรายละเอียดการเปลี่ยนแปลงผลลัพธ์",
    edit_promotion_signup: "แก้ไขการสมัครโปรโมชั่น",
    edit_bet_limit: "แก้ไขขีดจํากัดการเดิมพัน",
    edit_provider_game_off: "แก้ไขเกมผู้ให้บริการ",
    edit_provider_rtp: "แก้ไขผู้ให้บริการ RTP",
    get_rebate: "รับเงินคืน",
    get_recent_deposit: "รับเงินฝากล่าสุด",
    add_survey: "เพิ่มแบบสํารวจ",
    add_announcement_banner: "เพิ่มแบนเนอร์ประกาศ",
    edit_announcement_banner: "แก้ไขแบนเนอร์ประกาศ",
    move_announcement_banner: "ย้ายแบนเนอร์ประกาศ",
    add_promotion_banner: "เพิ่มแบนเนอร์โปรโมชั่น",
    edit_promotion_banner: "แก้ไขแบนเนอร์ส่งเสริมการขาย",
    move_promotion_banner: "ย้ายแบนเนอร์โปรโมชั่น",
    add_slide_banner: "เพิ่มแบนเนอร์สไลด์",
    edit_slide_banner: "แก้ไขแบนเนอร์สไลด์",
    move_slide_banner: "ย้ายแบนเนอร์สไลด์",
    add_seo_page: "เพิ่มหน้า SEO",
    edit_seo_page: "แก้ไขหน้า SEO",
    clear_outstanding: "ชัดเจนโดดเด่น",
    add_ip_whitelist: "เพิ่มรายการไวท์ลิสต์ IP",
    bonus_issue_bulk: "ปัญหาโบนัสจํานวนมาก",
    edit_bank_member_ewallet: "แก้ไขสมาชิกธนาคาร (E-Wallet)",
    redeposit: "ฝากเงินซ้ํา",
    reject_approved_ticket: "ปฏิเสธตั๋วที่ได้รับอนุมัติ",
    audit_ticket: "ตั๋วตรวจสอบ",
    review_ticket: "ตั๋วรีวิว",
    edit_promotion_group_norm_seq: "จัดการลําดับการส่งเสริมการขายในกลุ่ม",
    edit_promo_provider_list: "แก้ไขรายชื่อผู้ให้บริการส่งเสริมการขาย",
    edit_promo_payment_option: "แก้ไขตัวเลือกการชําระเงินโปรโมชั่น",
    edit_campaign_provider_list: "แก้ไขรายชื่อผู้ให้บริการแคมเปญ",
    update_comm: "อัปเดตค่าคอมมิชชั่น",
    update_carry_over: "อัปเดตยกยอดไป",
    review_affiliate_ticket: "ตรวจสอบตั๋วพันธมิตร",
    audit_affiliate_ticket: "ตั๋วพันธมิตรการตรวจสอบ",
    get_tac_affiliate: "รับ OTP (บริษัทในเครือ)",
    raise_deposit_ticket_gateway: "ตั๋วเงินฝากเพิ่ม (เกตเวย์)",
    direct_audit_ticket: "ตั๋วตรวจสอบ (โดยตรง)",
    get_rollback_detail: "รับรายละเอียดการย้อนกลับ",
    get_reject_detail: "ปฏิเสธรายละเอียด",
    manual_approve_ticket: "อนุมัติตั๋ว (คู่มือ)",
    add_label: "เพิ่มป้ายกํากับ",
    edit_label: "แก้ไขป้ายกํากับ",
    rollback_processing_ticket: "ตั๋วประมวลผลย้อนกลับ",
    update_iframe_url: "อัปเดต URL Iframe",
    edit_exchange_rate: "แก้ไขอัตราแลกเปลี่ยน",
    add_vip: "เพิ่มวีไอพี",
    add_turnover_tier: "เพิ่มระดับการหมุนเวียน",
    edit_turnover_tier: "แก้ไขระดับการหมุนเวียน",
    get_member_label_list: "รายชื่อสมาชิก",
    add_rescue_fund: "เพิ่มกองทุนกู้ภัย",
    get_custom_member_list: "รายชื่อสมาชิกที่กําหนดเอง",
    get_rescue_fund_provider: "รับผู้ให้บริการกองทุนกู้ภัย",
    add_game_exclude: "เพิ่มเกมยกเว้น",
    delete_game_exclude: "ลบเกมที่ไม่รวม",
    domain_custom_add_assign: "เพิ่มโดเมน",
    add_domain_batch: "เพิ่มโดเมน (ชุด)",
    update_payment_provider_vip: "อัปเดต Vip ผู้ให้บริการการชําระเงิน",
    update_campaign: "อัปเดตแคมเปญ",
    purchase_domain: "ซื้อโดเมน",
    apply_domain: "ใช้โดเมน",
    edit_access_control: "แก้ไขการควบคุมสิทธิ์การเข้าถึง",
    add_domain: "เพิ่มโดเมน",
    operator_wallet_adjust: "ปรับกระเป๋าเงินผู้ประกอบการ",
    update_payment_provider_desc: "อัปเดตคําอธิบายผู้ให้บริการการชําระเงิน",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "ตั้งค่าโลโก้",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "อัปเดตโอเปอเรเตอร์ PT ของผู้ให้บริการ",
    provider_pt_global_update: "อัปเดตทั่วโลก PT ของผู้ให้บริการ",
    payment_option_callback_update: "อัปเดต Callback URL",
    change_payment_option_seq: "ลำดับตัวเลือกการชำระเงิน",
    change_payment_mode_status: "อัปเดตสถานะตัวเลือกการชำระเงิน",
    change_payment_option_recommend: "แนะนำตัวเลือกการชำระเงิน",
    change_payment_option_credential: "ข้อมูลรับรองตัวเลือกการชำระเงิน",
    change_payment_option_limit: "ขีดจำกัดตัวเลือกการชำระเงิน",
    change_payment_option_vip: "ตัวเลือกการชำระเงินสำหรับ VIP",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
  },
  short: {
    deposit_amount: "เดปแอมต์",
    base_amount: "ฐาน Amt",
    bonus_amount: "โบนัส Amt",
    target_amount: "ทีอาร์จีที Amt",
    knockoff_by: "เคโอ บาย",
    knockoff_date: "เคโอเดท",
    incoming_threshold: "ในเทรส",
    incoming_frequency: "ในเฟรค",
    outgoing_threshold: "ออกเทรซ",
    outgoing_frequency: "ออกเฟรค",
    account_balance: "ACC BAL",
    claim_type: "ประเภทซี",
    bonus_rate: "อัตราบี",
    max_bonus: "เอ็มโบนัส",
    rollover: "โรลโอเวอร์",
    criteria: "เกณฑ์",
    start_time: "ส.ไทม์",
    end_time: "อีไทม์",
    monday: "จันทร์",
    tuesday: "ตู่",
    wednesday: "พุธ",
    thursday: "ธู",
    friday: "เพื่อน",
    saturday: "นั่ง",
    sunday: "ดวงอาทิตย์",
    status: "สถานะ",
    bonus_rate_percent: "อัตรา B (%)",
    valid_turnover: "วี.เทิร์นโอเวอร์",
    deposit_count: "ดีพ ซีเอ็นที",
    withdrawal_amount: "Wdw Amt",
    withdrawal_count: "ดับบลิวดีดับบลิว ซีเอ็นที",
    adjustment_amount: "แอดเจ Amt",
    referee_count: "ผู้ตัดสิน Cnt",
    signup_count: "ลงนาม Cnt",
    verified_count: "จํานวน VRF",
    active_member: "เอ็มบีเอ็มที่ใช้งานอยู่",
    ftd_count: "เอฟทีดี ซีเอ็นที",
    ftd_amount: "เอฟทีดี เอเอ็มที",
    working_date: "บีบ DT",
    recipient_bank_id: "ร.แบงค์ไอดี",
    recipient_bank_acc_no: "อาร์แบงก์ แอคซี เลขที่",
    recipient_bank_acc_holder: "ผู้ถือ R.Bank Acc",
    sender_bank: "เอส.แบงก์",
    sender_bank_acc_no: "เอส.แบงก์ แอคซี เลขที่",
    sender_bank_acc_holder: "ผู้ถือ S.Bank Acc",
    unique_login_count: "U.Login Cnt",
    unique_deposit_count: "นับฝากไม่ซ้ำ",
    unique_withdrawal_count: "UWdw Cnt",
    second_deposit_count: "เอส.เดป ซีเอ็นที",
    reject_date: "ร.ดาเตะ",
    processing_date: "ป.ดาเตะ",
    deposit_withdrawal_different: "Dep Wdw Diff",
    external_id: "อดีตบัตรประจําตัว",
    draft_version: "ร่าง เวอร์ชั่น",
    prod_version: "ผลิตภัณฑ์ เวอร์ชั่น",
    purchased_date: "ป วันที่",
    completed_amount: "Compl Amt"
  },
  date_ranges: {
    0: "วันนี้",
    1: "เมื่อวาน",
    2: "เดือนนี้",
    4: "เดือนที่แล้ว",
  },
  langList: {
    EN: "ภาษาอังกฤษ",
    CN: "จีน",
    PHP: "ฟิลิปปินส์",
    esp: "ภาษาสเปน",
    RUS: "ภาษารัสเซีย"
  },
  menulist: {
    home: "บ้าน",
    hot: "เกมร้อน",
    slot_game: "เกมสล็อต",
    casino: "คาสิโน",
    sportsbook: "สปอร์ตบุ๊ค",
    fishing: "ตกปลา",
    lottery: "ลอตเตอรี",
    poker: "โป๊กเกอร์",
    hash_game: "เกมแฮช",
    sabong: "สะบง",
    promotion: "การส่งเสริมการขาย",
    review: "รีวิว",
    news: "ข่าว",
    live_stream: "สตรีมสด",
    vip: "วีไอพี",
    referral: "ผู้อ้างอิง",
    favourite: "ที่ชื่นชอบ",
    mission: "ภารกิจ (มินิเกม)",
    spin: "หมุน",
    leaderboard: "กระดานผู้นํา",
    account: "บัญชี",
    deposit: "เงินฝาก",
    withdrawal: "การถอนตัว",
    bet_history: "ประวัติการเดิมพัน",
    pending_status: "สถานะที่รอดําเนินการ",
    change_password: "เปลี่ยนรหัสผ่าน",
    profile: "โปรไฟล์",
    banking_details: "รายละเอียดการธนาคาร",
    inbox: "กล่องจดหมาย",
    voucher: "บัตรกํานัล",
    wallet: "กระเป๋าเงิน",
    statement: "แถลงการณ์",
    download: "ดาวน์โหลด",
    game: "เกม",
    special: "พิเศษ",
    misc: "เบ็ดเตล็ด",
    contact_us: "ติดต่อเรา",
    e_sportsbook: "อีสปอร์ตบุ๊ค",
    lotto: "ล็อตโต้",
    p2p: "พีทูพี",
    other: "อื่นๆ",
    vip2: "วีไอพี2",
    referral2: "ผู้อ้างอิง2",
    event: "เหตุการณ์",
    daily_reward: "รางวัลรายวัน",
    play2earn: "เล่น 2 รับ",
    redemption: "การไถ่ถอน",
    card_board: "กระดานการ์ด",
    lobby: "ล็อบบี้",
    in_house: "ในบ้าน",
    transfer: "โอน",
    horse_racing: "การแข่งม้า",
    register: "ลงทะเบียน",
    login: "เข้าสู่ระบบ",
    transaction_history: "ประวัติการทําธุรกรรม",
    bingo: "บิงโก",
    member: "สมาชิก",
    arcade: "อาร์เคด",
    crash: "จรวดพนัน"
  },

  ok: "ตกลง",
  cancel: "ยกเลิก",
  login: "เข้าสู่ระบบ",
  logout: "ออกจากระบบ",
  add: "เพิ่ม",
  edit: "แก้ไข",
  delete: "ลบ",
  refresh: "รีเฟรช",
  action: "การกระทํา",
  id: "รหัส",
  name: "ชื่อ",
  all: "ทั้งหมด",
  search: "ค้นหา",
  remove: "ลบ",
  save: "บันทึก",
  account: "บัญชี",
  settings: "การตั้งค่า",
  on: "บน",
  off: "ปิด",
  new: "ใหม่",
  clear: "ชัดเจน",
  users: "ผู้ใช้ | ผู้ใช้",
  username: "ชื่อผู้ใช้",
  password: "รหัสผ่าน",
  created_on: "สร้างต่อ",
  active: "ใช้งานอยู่",
  page_size: "ขนาดหน้า",
  status: "สถานะ",
  result: "ผลลัพธ์",
  close: "ปิด",
  back: "กลับ",
  show: "แสดง",
  login_id: "รหัสเข้าสู่ระบบ",
  date_time: "วันที่เวลา",
  ip_address: "ที่อยู่ IP",
  domain_name: "ชื่อโดเมน",
  browser_agent: "ตัวแทนเบราว์เซอร์",
  action_by: "ดําเนินการโดย",
  details: "รายละเอียด",
  key: "กุญแจ | กุญแจ",
  value: "คุณค่า | ค่านิยม",
  from: "จาก",
  to: "ถึง",
  type: "ประเภท",
  criteria: "เกณฑ์",
  log: "บันทึก",
  report: "รายงาน",
  security_tag: "แท็กความปลอดภัย",
  security_code: "รหัสความปลอดภัย",
  submit: "ส่ง",
  disable: "ปิดการใช้งาน",
  operators: "ผู้ปฏิบัติงาน | ผู้ปฏิบัติงาน",
  members: "สมาชิก",
  account_id: "รหัสบัญชี",
  confirm_password: "ยืนยันรหัสผ่าน",
  full_name: "ชื่อเต็ม",
  contact_phone: "โทรศัพท์ติดต่อ",
  contact_email: "ติดต่ออีเมล",
  dashboard: "แดชบอร์ด",
  sub_account: "บัญชีย่อย",
  authority_option: "ตัวเลือกผู้มีอํานาจ",
  banks: "ธนาคาร | ธนาคาร",
  login_ip : "เข้าสู่ระบบไอพี",
  block: "บล็อก",
  profile_id: "รหัสโปรไฟล์",
  suspend: "ระงับ",
  dob: "ด๊อบ",
  mail_address: "ที่อยู่อีเมล",
  deposit: "เงินฝาก",
  withdrawal: "การถอนตัว",
  rejected: "ถูกปฏิเสธ",
  processed: "ดําเนินการแล้ว",
  pending: "รอดําเนินการ",
  member: "สมาชิก",
  amount: "จํานวนเงิน",
  bank_acc_no: "ธนาคาร Acc No.",
  deposit_date: "วันที่ฝาก",
  deposit_method: "วิธีการฝากเงิน",
  approve: "อนุมัติ",
  reject: "ปฏิเสธ",
  remark: "หมายเหตุ",
  ticket_detail: "รายละเอียดตั๋ว",
  promo: "โปรโมชั่น",
  package: "แพ็คเกจ",
  created_date: "วันที่สร้าง",
  currency: "สกุลเงิน",
  bank_acc_holder: "ผู้ถือบัญชีธนาคาร",
  ref_no: "หมายเลขอ้างอิง",
  vip: "วีไอพี",
  modified_date: "วันที่แก้ไข",
  modified_by: "แก้ไขโดย",
  bank_member: "สมาชิกธนาคาร",
  bank_operator: "ผู้ประกอบการธนาคาร",
  bank_name: "ชื่อธนาคาร",
  bank_acc_type: "ประเภทธนาคาร Acc",
  account_balance: "ยอดคงเหลือในบัญชี",
  threshold: "เกณฑ์",
  incoming: "กําลังมา",
  outgoing: "ออกไปข้างนอก",
  frequency: "ความถี่",
  reset_threshold: "รีเซ็ตเกณฑ์",
  adjust_balance: "ปรับสมดุล",
  bank_from: "ธนาคารจาก",
  bank_to: "ธนาคารเพื่อ",
  attachment: "ความผูกพัน",
  sender_bank: "ธนาคารผู้ส่ง",
  sender_bank_acc_no: "หมายเลขผู้ส่งธนาคาร Acc",
  sender_bank_acc_holder: "ผู้ถือ Acc ของธนาคารผู้ส่ง",
  audit: "ตรวจสอบ",
  action_status: "สถานะการดําเนินการ",
  action_date: "วันที่ดําเนินการ",
  promotion: "การส่งเสริมการขาย",
  promo_id: "โปรโมชันไอดี",
  promo_name: "ชื่อโปรโมชั่น",
  package_id: "รหัสแพ็คเกจ",
  claim_type: "ประเภทการเรียกร้อง",
  bonus_rate: "อัตราโบนัส",
  max_bonus: "โบนัสสูงสุด",
  rollover: "โรลโอเวอร์",
  start_date: "วันที่เริ่มต้น",
  end_date: "สิ้นสุดวันที่",
  adj_amount: "ปรับจํานวนเงิน",
  promotion_member: "สมาชิกโปรโมชั่น",
  on_going: "กําลังไป",
  knock_off: "เคาะออก",
  all_ongoing: "ดําเนินต่อไปทั้งหมด",
  deposit_amount: "จํานวนเงินฝาก",
  base_amount: "จํานวนฐาน",
  bonus_amount: "จํานวนเงินโบนัส",
  target_amount: "จํานวนเป้าหมาย",
  claim_date: "วันที่เรียกร้อง",
  accumulate_win: "สะสมชัยชนะ",
  accumulate_turnover: "สะสมมูลค่าการซื้อขาย",
  bonus: "โบนัส",
  bonus_log: "บันทึกโบนัส",
  member_id: "รหัสสมาชิก",
  before_balance: "ก่อนยอดคงเหลือ",
  transfer_amount: "จํานวนเงินโอน",
  after_balance: "หลังยอดคงเหลือ",
  created_by: "สร้างโดย",
  bonus_name: "ชื่อโบนัส",
  bonus_desc: "คําอธิบายโบนัส",
  bonus_type: "ประเภทโบนัส",
  add_promo: "เพิ่มโปรโมชั่น",
  bonus_value: "มูลค่าโบนัส",
  attach_promo: "แนบโปรโมชั่น",
  daily_statement: "แถลงการณ์รายวัน",
  working_date: "วันทํางาน",
  opening_balance: "การเปิดสมดุล",
  turnover: "เทิร์นโอเวอร์",
  valid_turnover: "การหมุนเวียนที่ถูกต้อง",
  winlose: "วินแพ้",
  withdrawal_amount: "จํานวนเงินถอน",
  closing_balance: "การปิดยอดคงเหลือ",
  sub_total: "ยอดรวมย่อย",
  grand_total: "ยอดรวม",
  daily_winlose: "เดลี่วินลอส",
  game_result_slots: "ผลลัพธ์ของเกม (สล็อต)",
  game_result_livecasino: "ผลลัพธ์ของเกม (Livecasino)",
  game_result_rebate: "ผลเกม (โต้วาที)",
  game_result_sportsbook: "ผลการแข่งขัน (สปอร์ตบุ๊ค)",
  game_result_cockfight: "ผลการแข่งขัน (ไก่ชน)",
  game_result_rescue: "ผลลัพธ์ของเกม (กู้ภัย)",
  bet_count: "เดิมพันนับ",
  result_id: "รหัสผลลัพธ์",
  bet_time: "เวลาเดิมพัน",
  payout: "การจ่ายเงิน",
  game_type: "ประเภทเกม",
  game_name: "ชื่อเกม",
  game_provider: "ผู้ให้บริการเกม",
  reset: "รีเซ็ต",
  mode: "โหมด",
  balance: "ความสมดุล",
  min_bal_knock_off_promo: "มินบาล (เพื่อปิดการโปรโมตอัตโนมัติ)",
  social_account: "บัญชีโซเชียล",
  wechat: "วีแชท",
  telegram: "โทรเลข",
  whatsapp: "วอทส์แอพ",
  facebook: "เฟซบุ๊ก",
  instagram: "อินสตาแกรม",
  login_log: "เข้าสู่ระบบเข้าสู่ระบบ",
  platform: "แพลตฟอร์ม",
  bank_statement: "ใบแจ้งยอดธนาคาร",
  transfer_date: "วันที่โอน",
  detail: "รายละเอียด",
  date: "วันที่",
  transfer_list: "รายการโอน",
  credit: "เครดิต",
  debit: "เดบิต",
  month: "เดือน",
  unblock: "ปลดบล็อก",
  unblock_member: "ปลดบล็อกสมาชิก",
  unblock_operator: "ปลดบล็อกโอเปอเรเตอร์",
  referrer_id: "รหัสผู้อ้างอิง",
  referrer_code: "รหัสผู้อ้างอิง",
  referral_code: "รหัสอ้างอิง",
  bonus_and_adjustment: "โบนัสและการปรับ",
  adjustment: "การปรับตัว",
  incoming_amount_threshold: "เกณฑ์จํานวนเงินที่เข้ามา",
  outgoing_amount_threshold: "เกณฑ์จํานวนเงินขาออก",
  knock_off_by: "เคาะออกโดย",
  knock_off_date: "เคาะวันที่",
  total_turnover: "มูลค่าการซื้อขายรวม",
  total_winlose: "วินลอสทั้งหมด",
  total_deposit: "เงินฝากทั้งหมด",
  total_member: "สมาชิกทั้งหมด",
  active_player: "ผู้เล่นที่ใช้งานอยู่",
  top_winner: "ผู้ชนะอันดับต้น ๆ",
  top_loser: "ผู้แพ้อันดับต้น ๆ",
  winner: "ผู้ชนะ",
  loser: "ผู้แพ้",
  deposit_count: "จํานวนเงินฝาก",
  withdrawal_count: "จํานวนการถอน",
  alert: "แจ้งเตือน",
  incoming_threshold: "เกณฑ์ที่เข้ามา",
  incoming_frequency: "ความถี่ขาเข้า",
  outgoing_threshold: "เกณฑ์ขาออก",
  outgoing_frequency: "ความถี่ขาออก",
  reset_password: "รีเซ็ตรหัสผ่าน",
  transfer: "โอน",
  company_bank: "ธนาคารบริษัท",
  company_bank_acc_no: "บริษัท ธนาคาร Acc No.",
  company_bank_acc_holder: "ผู้ถือ Acc ของธนาคารบริษัท",
  registered_member: "สมาชิกที่ลงทะเบียน",
  promotion_report: "รายงานการส่งเสริมการขาย",
  deposited_member: "สมาชิกฝาก",
  referred_member: "สมาชิกอ้างอิง",
  validated_on: "ผ่านการตรวจสอบแล้ว",
  first_deposit: "เงินฝากครั้งแรก",
  reward: "รางวัล",
  inbox: "กล่องจดหมาย",
  manual_bonus: "โบนัสด้วยตนเอง",
  review: "รีวิว | รีวิว",
  reviews: "บทวิจารณ์",
  review_list: "รายการทบทวน",
  review_detail: "รายละเอียดการตรวจสอบ",
  reply_review: "ตอบกลับรีวิว",
  comment: "ความคิดเห็น",
  reply: "ตอบกลับ",
  recipient_no: "ผู้รับหมายเลข",
  question : "คําถาม",
  rating: "การให้คะแนน",
  content: "เนื้อหา",
  image: "ภาพ",
  monthly_rating: "เรตติ้งรายเดือน",
  affiliate: "พันธมิตร",
  affiliate_list: "รายชื่อพันธมิตร",
  affiliate_code: "รหัสพันธมิตร",
  approved_by: "อนุมัติโดย",
  approved_date: "วันที่อนุมัติ",
  bank_affiliate: "พันธมิตรธนาคาร",
  bank_id: "รหัสธนาคาร",
  ticket_detail_affiliate: "พันธมิตรรายละเอียดตั๋ว",
  pending_application: "ใบสมัครที่รอดําเนินการ",
  pending_review_withdrawal: "รอดําเนินการและทบทวนการถอนเงิน",
  unblock_affiliate: "ปลดบล็อกพันธมิตร",
  wallet_adjust: "ปรับกระเป๋าเงิน",
  comm_package: "แพ็คเกจการสื่อสาร",
  affiliate_id: "รหัสพันธมิตร",
  sub_account_detail: "รายละเอียดบัญชีย่อย",
  daily_winlose_affiliate: "เดลี่ วินลอส (พันธมิตร)",
  daily_deposit_affiliate: "เงินฝากรายวัน (พันธมิตร)",
  export_excel: "ส่งออก Excel",
  get_tac: "รับ สนข.",
  tac_code: "รหัส OTP",
  expiry_date: "วันหมดอายุ",
  inactive: "ไม่ได้ใช้งาน",
  last_deposit_date: "วันที่ฝากครั้งสุดท้าย",
  coupon: "คูปอง",
  allocated: "จัดสรรแล้ว",
  claimed: "อ้างสิทธิ์",
  approved: "อนุมัติ",
  coupon_code: "รหัสคูปอง",
  coupon_quota: "โควต้าคูปอง",
  current_allocated: "จัดสรรปัจจุบัน",
  new_allocated: "จัดสรรใหม่",
  update : "อัปเดต",
  copy: "คัดลอก",
  bonus_rate_percent : "อัตราโบนัส (%)",
  coupon_desc: "คําอธิบายคูปอง",
  both: "ทั้งสอง",
  issue_free_spin: "ออกฟรีสปิน",
  game: "เกม",
  max_win_amount: "จํานวนเงินที่ชนะสูงสุด",
  utm_list: "รายการ UTM",
  search_by_member: "ค้นหาโดยสมาชิก",
  campaign: "แคมเปญ",
  deposited: "ฝากไว้",
  search_by_id: "ค้นหาตาม ID",
  get_bank_tac: "รับ OTP ธนาคาร",
  bank_statement_daily: "ใบแจ้งยอดธนาคาร (รายวัน)",
  transfer_type: "ประเภทการโอน",
  audit_freebies_list: "รายการตรวจสอบของสมนาคุณ",
  acknowledge: "รับทราบ",
  submit_acknowledgement: "ส่งการรับทราบ",
  is_ack: "คือแอค",
  yes: "ใช่",
  no: "เลขที่",
  audit_rescue_fund_list: "รายชื่อกองทุนกู้ภัยตรวจสอบ",
  global_setting: "การตั้งค่าทั่วโลก",
  signup_ip: "ลงทะเบียน IP",
  last_login_ip: "IP เข้าสู่ระบบครั้งล่าสุด",
  last_login_time: "เวลาเข้าสู่ระบบครั้งสุดท้าย",
  link: "ลิงค์",
  is_default: "เป็นค่าเริ่มต้น",
  is_public: "เป็นสาธารณะ",
  bank_group: "กลุ่มธนาคาร",
  set_default: "ตั้งค่าเริ่มต้น",
  group_id: "รหัสกลุ่ม",
  group_name: "ชื่อกลุ่ม",
  provider_maintenance: "การบํารุงรักษาผู้ให้บริการ",
  provider_code: "รหัสผู้ให้บริการ",
  provider_name: "ชื่อผู้ให้บริการ",
  withdrawal_limit: "ขีดจํากัดการถอน",
  limit_id: "จํากัดรหัส",
  limit_name: "ชื่อจํากัด",
  daily_amount: "จํานวนเงินรายวัน",
  daily_frequency: "ความถี่รายวัน",
  promotion_id: "รหัสส่งเสริมการขาย",
  promotion_name: "ชื่อโปรโมชั่น",
  withhold_bonus: "ระงับโบนัส",
  withhold_amount: "จํานวนเงินระงับ",
  withhold_amt: "ระงับ Amt",
  max_withdraw_amt: "แม็กซ์ถอน Amt",
  max_withdraw_amount: "จํานวนเงินถอนสูงสุด",
  monday: "วันจันทร์",
  tuesday: "วันอังคาร",
  wednesday: "วันพุธ",
  thursday: "วันพฤหัสบดี",
  friday: "วันศุกร์",
  saturday: "วันเสาร์",
  sunday: "วันอาทิตย์",
  start_time: "เวลาเริ่มต้น",
  end_time: "เวลาสิ้นสุด",
  day: "วัน | วัน",
  coupon_status: "สถานะคูปอง",
  campaign_id: "รหัสแคมเปญ",
  campaign_name: "ชื่อแคมเปญ",
  promotion_group: "กลุ่มส่งเสริมการขาย",
  referee_list: "รายชื่อผู้ตัดสิน",
  account_verified: "บัญชีตรวจสอบแล้ว",
  verified_date: "วันที่ยืนยัน",
  ticket_list: "รายการตั๋ว",
  vip_id: "รหัสวีไอพี",
  vip_name: "ชื่อวีไอพี",
  self_rebate_rate: "อัตราการคืนเงินด้วยตนเอง(%)",
  downline_rebate_rate: "อัตราการคืนเงินดาวน์ไลน์(%)",
  provider: "ผู้ให้บริการ",
  match_id: "รหัสการแข่งขัน",
  home_team: "ทีมเหย้า",
  away_team: "ทีมเยือน",
  home_team_new: "ทีมเหย้าใหม่",
  away_team_new: "ทีมเยือนใหม่",
  updated_by: "อัปเดตโดย",
  updated_on: "อัปเดตเมื่อ",
  home_score: "คะแนนบ้าน",
  away_score: "คะแนนห่าง",
  home_score_new: "คะแนนบ้านใหม่",
  away_score_new: "คะแนนทีมเยือนใหม่",
  team: "ทีม",
  match_time: "เวลาแข่งขัน",
  match_round: "รอบการแข่งขัน",
  home_group: "โฮมกรุ๊ป",
  away_group: "กลุ่มเยือน",
  match: "จับคู่",
  match_status: "สถานะการแข่งขัน",
  insert: "แทรก",
  pin: "พิน",
  bet_list: "รายการเดิมพัน",
  result_list: "รายการผลลัพธ์",
  bet_id: "รหัสเดิมพัน",
  bet_home: "เดิมพันที่บ้าน",
  bet_away: "เดิมพันออกไป",
  bet_on: "เดิมพันเลย",
  min_deposit: "เงินฝากขั้นต่ํา",
  min_withdrawal: "การถอนขั้นต่ํา",
  raise_deposit_ticket: "ตั๋วเงินฝากเพิ่ม",
  method: "วิธีการ",
  one_time_depositor: "ผู้ฝากครั้งเดียว",
  current_month_non_depositor: "เดือนปัจจุบันไม่ใช่ผู้ฝาก",
  current_month_no_login: "เดือนปัจจุบันไม่มีการเข้าสู่ระบบ",
  ticket_date: "วันที่ตั๋ว",
  ftd_amount: "เอฟทีดี เอเอ็มที",
  bonus_issue: "ปัญหาโบนัส",
  promotion_summary: "สรุปการส่งเสริมการขาย",
  promotion_summary_detail: "สรุปโปรโมชั่น (รายละเอียด)",
  claim_frequency: "ความถี่ในการเรียกร้อง",
  provider_list: "รายชื่อผู้ให้บริการ",
  platform_winlose: "แพลตฟอร์มวินลอส",
  adjustment_amount: "จํานวนเงินที่ปรับ",
  referee_count: "จํานวนผู้ตัดสิน",
  category: " 'หมวดหมู่',",
  update_vip: "อัพเดทวีไอพี",
  promotion_signup: "การลงทะเบียนโปรโมชั่น",
  provider_bet_limit: "ผู้ให้บริการเดิมพันจํากัด",
  update_member_bet_limit: "อัปเดตขีดจํากัดการเดิมพันของสมาชิก",
  bet_limit: "ขีดจํากัดการเดิมพัน",
  sports_game: "กีฬา/เกม",
  league_name: "ชื่อลีก",
  home_team_name: "ชื่อทีมเหย้า",
  away_team_name: "ชื่อทีมเยือน",
  wl_status: "สูญเสียสถานะ",
  available_bank_account: "บัญชีธนาคารที่มีอยู่",
  group_bank_account: "บัญชีธนาคารกลุ่ม",
  edit_bank_group: "แก้ไขกลุ่มธนาคาร",
  edit_bank_account_group: "แก้ไขกลุ่มบัญชีธนาคาร",
  redeposit: "ฝากเงินซ้ํา",
  upline: "อัพไลน์",
  downline: "ดาวน์ไลน์",
  available_promotion: "โปรโมชั่นที่มีอยู่",
  group_promotion: "การส่งเสริมกลุ่ม",
  edit_promotion_group: "แก้ไขกลุ่มส่งเสริม",
  edit_promotion_group_norm: "จัดการการส่งเสริมการขายในกลุ่ม",
  balance_before: "ความสมดุลก่อน",
  balance_after: "ความสมดุลหลังจากนั้น",
  signup_count: "จํานวนการลงทะเบียน",
  verified_count: "จํานวนที่ยืนยันแล้ว",
  active_member: "สมาชิกที่ใช้งานอยู่",
  ftd_count: "จํานวน FTD",
  daily_summary_company: "สรุปรายวัน (บริษัท)",
  daily_summary_operator: "สรุปรายวัน (ผู้ดําเนินการ)",
  daily_summary_member: "สรุปรายวัน (สมาชิก)",
  daily_ledger_operator: "บัญชีแยกประเภทรายวัน (ผู้ดําเนินการ)",
  bonus_list: "รายการโบนัส",
  ltd_date: "วันที่จํากัด",
  adjustment_log: "บันทึกการปรับเปลี่ยน",
  get_inbox: "รับกล่องจดหมาย",
  is_claimed: "ถูกอ้างสิทธิ์",
  mix_parlay: "มิกซ์พาร์เลย์",
  event: "เหตุการณ์",
  result_changes_log: "บันทึกการเปลี่ยนแปลงผลลัพธ์",
  view_detail: "ดูรายละเอียด",
  total_referee: "ผู้ตัดสินทั้งหมด",
  verified_signup: "ตรวจสอบแล้ว/ลงทะเบียน",
  ftd: "FTD | การฝากเงินครั้งแรก",
  raw_msg: "ข้อความดิบ",
  unselect_all: "ยกเลิกการเลือกทั้งหมด",
  select_all: "เลือกทั้งหมด",
  edit_bet_limit: "แก้ไขขีดจํากัดการเดิมพัน",
  provider_game_off: "ผู้ให้บริการเกมปิด",
  provider_hot_game: "ผู้ให้บริการเกมร้อน",
  game_id : "รหัสเกม",
  game_list: "รายชื่อเกม",
  off_list: "นอกรายการ",
  provider_rtp: "ผู้ให้บริการ RTP",
  rtp: "รทป",
  signup_date: "วันที่ลงทะเบียน",
  free_credit: "เครดิตฟรี",
  downline_rebate: "ส่วนลดดาวน์ไลน์",
  game_rebate: "การคืนเงินเกม",
  rebate: "โต้วาที",
  ftd_date: "วันที่ FTD",
  provider_winlose_company: "ผู้ให้บริการ Winlose (บริษัท)",
  provider_winlose_operator: "ผู้ให้บริการ Winlose (ผู้ดําเนินการ)",
  already_hit: "ตีแล้ว",
  ongoing: "กําลังดําเนินอยู่",
  members_export: "สมาชิก (ส่งออก)",
  get_recent_deposit: "รับเงินฝากล่าสุด",
  recent_deposit: "เงินฝากล่าสุด",
  survey_list: "รายการสํารวจ",
  modified_on: "แก้ไขแล้ว",
  cms: "ซีเอ็มเอส",
  announcement_banner: "ป้ายประกาศ",
  promotion_banner: "แบนเนอร์ส่งเสริมการขาย",
  slide_banner: "แบนเนอร์สไลด์",
  seo_page: "ซอเพจ",
  en_title: "ชื่อเรื่อง (EN)",
  cn_title: "ชื่อเรื่อง (CN)",
  local_title: "ชื่อเรื่อง (ท้องถิ่น)",
  en_img: "ภาพ (EN)",
  cn_img: "ภาพ (CN)",
  local_img: "ภาพ (ท้องถิ่น)",
  before_login: "ก่อนเข้าสู่ระบบ",
  after_login: "หลังจากเข้าสู่ระบบ",
  en: "EN",
  move_up: "ขยับขึ้น",
  move_down: "เลื่อนลง",
  banner_type: "ประเภทแบนเนอร์",
  default_order: "คําสั่งเริ่มต้น",
  item_order: "การสั่งซื้อสินค้า",
  title: "ชื่อเรื่อง",
  banner_id: "รหัสแบนเนอร์",
  order: "สั่งซื้อ",
  body: "ร่างกาย",
  en_image: "ภาพ (EN)",
  local_image: "ภาพ (ท้องถิ่น)",
  move: "ย้าย",
  en_img_desktop: "อิมเมจเดสก์ท็อป (EN)",
  cn_img_desktop: "อิมเมจเดสก์ท็อป (CN)",
  local_img_desktop: "อิมเมจเดสก์ท็อป (LOCAL)",
  en_img_mobile: "อิมเมจมือถือ (EN)",
  cn_img_mobile: "อิมเมจมือถือ (CN)",
  local_img_mobile: "ภาพมือถือ (ท้องถิ่น)",
  login_required: "ต้องเข้าสู่ระบบ",
  new_window_tab: "หน้าต่างใหม่/แท็บ",
  current_page: "หน้าปัจจุบัน",
  target: "เป้าหมาย",
  alt: "อัลท์",
  href: "เฮรฟ",
  image_desktop: "ภาพเดสก์ท็อป",
  image_mobile: "ภาพมือถือ",
  en_alt: "อัลท์ (EN)",
  local_alt: "อัลท์ (ท้องถิ่น)",
  en_href: "เฮรฟ (EN)",
  local_href: "Href (ท้องถิ่น)",
  en_image_desktop: "ภาพเดสก์ท็อป (EN)",
  active_period: "ช่วงที่ใช้งานอยู่",
  en_item: "รายการ (EN)",
  local_item: "รายการ (ท้องถิ่น)",
  meta_title: "ชื่อเมตา",
  meta_keywords: "คําหลักเมตา",
  meta_url: "Meta URL",
  meta_canonical: "เมตาคาโนนิคัล",
  meta_author: "ผู้เขียนเมตา",
  meta_publisher: "สํานักพิมพ์เมตา",
  meta_lang: "เมต้าหลาง",
  meta_desc: "เมตา เดสก์",
  meta_image: "เมต้าอิมเมจ",
  page: "หน้า",
  item: "รายการ",
  remove_desktop_image: "ลบภาพเดสก์ท็อป",
  remove_mobile_image: "ลบภาพมือถือ",
  page_name: "ชื่อหน้า",
  login_date: "วันที่เข้าสู่ระบบ",
  ftd_amount_min: "จํานวนขั้นต่ํา FTD",
  ftd_amount_max: "แม็กซ์ จํานวน FTD",
  fl_provider_code: "ผู้ให้บริการเปิดตัวครั้งแรก",
  fl_game_id: "รหัสเกมเปิดตัวครั้งแรก",
  fl_game_name: "ชื่อเกมเปิดตัวครั้งแรก",
  top_deposit: "เงินฝากยอดนิยม",
  top_withdrawal: "การถอนเงินยอดนิยม",
  top_promotion: "โปรโมชั่นยอดนิยม",
  outstanding_balance: "ยอดคงเหลือดีเด่น",
  last_update_time: "เวลาอัปเดตครั้งล่าสุด",
  trace: "เทรซ",
  trace_outstanding: "ร่องรอยโดดเด่น",
  outstanding: "โดดเด่น",
  clear_outstanding: "ชัดเจนโดดเด่น",
  meta_image_url: "Meta Image Url",
  member_bonus: "โบนัสสมาชิก",
  crm_list: "รายการ CRM",
  advance_search: "ค้นหาล่วงหน้า",
  deposit_count_from: "จํานวนเงินฝากจาก",
  deposit_count_to: "เงินฝากนับถึง",
  deposit_amount_from: "จํานวนเงินฝากจาก",
  deposit_amount_to: "จํานวนเงินฝากถึง",
  min_day_no_login: "นาที วันที่ไม่มีการเข้าสู่ระบบ",
  min_day_no_deposit: "มิน วันไม่มีเงินฝาก",
  last_login: "เข้าสู่ระบบครั้งสุดท้าย",
  last_deposit: "เงินฝากครั้งสุดท้าย",
  phone: "โทรศัพท์",
  email: "อีเมล",
  ip_whitelist: "ไอพี ไวท์ลิสต์",
  ip: "ไอพี",
  payment_option: "ตัวเลือกการชําระเงิน",
  payment_mode: "โหมดการชําระเงิน",
  payment_desc: "รายละเอียดการชําระเงิน",
  success: "ความสําเร็จ",
  failed: "ล้มเหลว",
  bank_member_ewallet: "สมาชิกธนาคาร (E-Wallet)",
  processing: "การประมวลผล",
  recipient_bank_id: "รหัสธนาคารผู้รับ",
  recipient_bank_acc_no: "หมายเลขบัญชีผู้รับธนาคาร",
  ticket_auto_withdrawal_log: "บันทึกตั๋ว (ถอนอัตโนมัติ)",
  resubmit_ticket: "ส่งตั๋วอีกครั้ง",
  ticket_export: "ตั๋ว (ส่งออก)",
  export_deposit: "ส่งออก (ฝาก)",
  export_deposit_all: "ส่งออกทั้งหมด (เงินฝาก)",
  export_withdrawal: "ส่งออก (ถอน)",
  export_withdrawal_all: "ส่งออกทั้งหมด (ถอน)",
  export_member_all: "ส่งออกทั้งหมด (สมาชิก)",
  processed_rejected: "ดําเนินการแล้ว (ถูกปฏิเสธ)",
  channel: "ช่อง",
  influencer: "ผู้มีอิทธิพล",
  ticket_id: "รหัสตั๋ว",
  recommend: "แนะนํา",
  sequence: "ลําดับ",
  statement_info: "ข้อมูลคําชี้แจง",
  slots: "สล็อต",
  livecasino: "ไลฟ์คาสิโน",
  sportsbook: "สปอร์ตบุ๊ค",
  cockfight: "ไก่ชน",
  member_list: "รายชื่อสมาชิก",
  operator: "โอเปอเรเตอร์",
  game_balance: "ความสมดุลของเกม",
  claim_limit: "ขีดจํากัดการเรียกร้อง",
  max_withdraw_multiple: "สูงสุดถอนหลายรายการ",
  payment_gateway: "เกตเวย์การชําระเงิน",
  min_limit: "ขีดจํากัดขั้นต่ํา",
  max_limit: "ขีดจํากัดสูงสุด",
  total: "ทั้งหมด",
  rebate_summary: "สรุปการอภิปราย",
  rebate_summary_daily: "สรุปการอภิปรายรายวัน",
  rebate_member: "สมาชิกโต้วาที",
  self: "ตนเอง",
  system_balance: "ความสมดุลของระบบ",
  rejected_onload: "ถูกปฏิเสธ (ออนโหลด)",
  no_bonus: "ไม่มีโบนัส",
  audit_ticket: "ตั๋วตรวจสอบ",
  review_ticket: "ตั๋วรีวิว",
  edit_promotion_group_norm_seq: "จัดการลําดับการส่งเสริมการขายในกลุ่ม",
  signup_bonus: "โบนัสการลงทะเบียน",
  settlement_type: "ประเภทการชำระบัญชี",
  carry_over: "ยกยอดไป",
  comm_sports: "ค่าคอมมิชชั่น (กีฬา)",
  comm_slots: "ค่าคอมมิชชั่น (สล็อต)",
  comm_livecasino: "ค่าคอมมิชชั่น (Livecasino)",
  comm_cockfight: "คณะกรรมการ (ไก่ชน)",
  comm_others: "คณะกรรมการ (อื่นๆ)",
  update_comm: "อัปเดตค่าคอมมิชชั่น",
  update_carry_over: "อัปเดตยกยอดไป",
  ewallet: "อี-วอลเล็ต",
  withdrawal_list: "รายการถอนเงิน",
  audit_withdrawal: "การถอนการตรวจสอบ",
  daily_withdrawal: "การถอนรายวัน",
  adjustment_log_affiliate: "บันทึกการปรับเปลี่ยน",
  daily_statement_affiliate: "แถลงการณ์รายวัน (บริษัทในเครือ)",
  earning: "รายได้",
  pnl: "พีแอนด์แอล",
  review_affiliate_ticket: "ตรวจสอบตั๋วพันธมิตร",
  audit_affiliate_ticket: "ตั๋วพันธมิตรการตรวจสอบ",
  turnover_downline: "เทิร์นโอเวอร์ (ดาวน์ไลน์)",
  valid_turnover_downline: "มูลค่าการซื้อขายที่ถูกต้อง (ดาวน์ไลน์)",
  winlose_downline: "วินลอส (ดาวน์ไลน์)",
  bet_count_downline: "เดิมพันนับ (ดาวน์ไลน์)",
  turnover_member: "เทิร์นโอเวอร์ (สมาชิก)",
  valid_turnover_member: "การหมุนเวียนที่ถูกต้อง (สมาชิก)",
  winlose_member: "วินลอส (สมาชิก)",
  bet_count_member: "เดิมพันนับ (สมาชิก)",
  dashboard_affiliate: "แดชบอร์ด (บริษัทในเครือ)",
  total_agent: "ตัวแทนทั้งหมด",
  top_turnover: "มูลค่าการซื้อขายสูงสุด",
  bonus_count: "การนับโบนัส",
  deposit_amount_downline: "จํานวนเงินฝาก (ดาวน์ไลน์)",
  deposit_count_downline: "จํานวนเงินฝาก (ดาวน์ไลน์)",
  bonus_amount_downline: "จํานวนเงินโบนัส (ดาวน์ไลน์)",
  bonus_count_downline: "การนับโบนัส (ดาวน์ไลน์)",
  deposit_amount_member: "จํานวนเงินฝาก (สมาชิก)",
  deposit_count_member: "จํานวนเงินฝาก (สมาชิก)",
  bonus_amount_member: "จํานวนเงินโบนัส (สมาชิก)",
  bonus_count_member: "การนับโบนัส (สมาชิก)",
  verified: "ยืนยันแล้ว",
  round_id: "รหัสรอบ",
  unfinish_round: "รอบไม่เสร็จ",
  smartico_bonus_report: "รายงานโบนัสอัจฉริยะ",
  unclaimed_amount: "จํานวนเงินที่ไม่มีการอ้างสิทธิ์",
  claimed_amount: "จํานวนเงินที่เรียกร้อง",
  unclaimed_count: "จํานวนที่ไม่มีการอ้างสิทธิ์",
  claimed_count: "อ้างสิทธิ์นับ",
  submit_time: "วันที่สร้าง",
  deposit_time: "วันที่แก้ไข",
  funds_list: "รายการตั๋ว",
  daifu_list_auto_withdrawal: "รายการตั๋ว (ถอนอัตโนมัติ)",
  btn_href: "ปุ่ม Href",
  btn_text: "ข้อความปุ่ม",
  recent_inbox_claim: "การเรียกร้องกล่องจดหมายล่าสุด",
  raise_deposit_ticket_gateway: "ตั๋วเงินฝากเพิ่ม (เกตเวย์)",
  gateway_acc: "บัญชีเกตเวย์",
  provider_winlose_member: "ผู้ให้บริการ Winlose (สมาชิก)",
  review_by: "รีวิวโดย",
  daifu_list_auto_withdrawal_export: "การส่งออกตั๋ว (การถอนอัตโนมัติ)",
  retention: "เรเทนตัน",
  current_month_active_user: "ผู้ใช้ที่ใช้งานเดือนปัจจุบัน",
  current_month_active: "เดือนปัจจุบันที่ใช้งานอยู่",
  first_month: "เดือนแรก",
  fmwinlose: "เอฟเอ็มวินลอส",
  fmdeposit_amount: "จํานวนเงินฝาก FM",
  cohort: "กลุ่มร่วมรุ่น",
  promotion_withdrawal_summary: "สรุปการถอนโปรโมชั่น",
  unique_player: "ผู้เล่นที่ไม่เหมือนใคร",
  year: "ปี | ปี",
  audit_time_modified: "วันที่แก้ไข",
  audit_time_created: "วันที่สร้าง",
  approve_time: "วันที่แก้ไข",
  unique_login_count: "จํานวนการเข้าสู่ระบบที่ไม่ซ้ําใคร",
  unique_deposit_count: "จำนวนการฝากไม่ซ้ำ",
  unique_withdrawal_count: "จํานวนการถอนที่ไม่ซ้ําใคร",
  second_deposit_count: "จํานวนเงินฝากครั้งที่สอง",
  unique_login: "เข้าสู่ระบบไม่ซ้ําใคร",
  unique_withdrawal: "การถอนเงินที่ไม่ซ้ําใคร",
  second_deposit: "เงินฝากครั้งที่สอง",
  deposit_withdrawal_different: "การถอนเงินฝากแตกต่างกัน",
  ngr: "เอ็นจีอาร์",
  audit_list: "รายการตรวจสอบ",
  rollback_count: "จํานวนย้อนกลับ",
  rejected_ticket_id: "บัตรโดยสารที่ถูกปฏิเสธ",
  rollback: "ย้อนกลับ",
  recipient_bank_acc_holder: "ผู้ถือ Acc ของธนาคารผู้รับ",
  reject_date: "ปฏิเสธวันที่",
  processing_date: "วันที่ดําเนินการ",
  manual_approve: "อนุมัติ (คู่มือ)",
  pending_review_funds: "ตั๋วที่รอดําเนินการและทบทวน",
  table_id: "รหัสตาราง",
  member_label: "ฉลากสมาชิก",
  label_name: "ชื่อป้ายกํากับ",
  label: "ฉลาก",
  available_label: "ฉลากที่มีอยู่",
  iframe: "ไอฟราม",
  iframe_url: "ยูอาร์แอลไอเฟรม",
  exchange_rate: "อัตราแลกเปลี่ยน",
  rate: "อัตรา",
  rate_php: "อัตรา PHP",
  ticket_withdrawal_rollback: "การถอนตั๋วย้อนกลับ",
  smartico_bonus_report_expired: "รายงานโบนัส Smartico (หมดอายุ)",
  reward_type: "ประเภทรางวัล",
  turnover_rebate: "เงินคืนจากยอดเทิร์นโอเวอร์",
  turnover_rebate_1: "ระดับวีไอพี",
  turnover_rebate_2: "ระดับเทิร์นโอเวอร์",
  vip_cycle_day: "วันรอบวีไอพี",
  is_addon: "คือแอดดอน",
  no_reward: "ไม่มีรางวัล",
  cash: "เงินสด",
  cs: "การบริการลูกค้า",
  social_platform: "แพลตฟอร์มโซเชียล",
  edit_vip: "แก้ไขวีไอพี",
  edit_vip_provider: "แก้ไขผู้ให้บริการวีไอพี",
  turnover_tier: "ระดับเทิร์นโอเวอร์",
  rebate_rate: "อัตราการโต้วาที",
  edit_turnover_tier: "แก้ไขระดับการหมุนเวียน",
  delete_turnover_tier: "ลบระดับการหมุนเวียน",
  vip_log: "บันทึกวีไอพี",
  member_full_record: "สมาชิกบันทึกเต็ม",
  before: "ก่อน",
  after: "หลังจากนั้น",
  maintain: "รักษา",
  actual_rebate: "การคืนเงินจริง",
  rounded_rebate: "การรีเบตแบบกลม",
  rebate_mode: "โหมดโต้วาที",
  inbox_id: "รหัสกล่องจดหมาย",
  rebate_type: "ประเภทการอภิปราย",
  promotion_type: "ประเภทโปรโมชั่น",
  bonus_rate_1: "อัตรา 1(%)",
  bonus_rate_2: "อัตรา 2(%)",
  bonus_rate_3: "อัตรา 3(%)",
  bonus_rate_4: "อัตรา 4(%)",
  bonus_rate_5: "อัตรา 5(%)",
  bonus_rate_6: "อัตรา 6(%)",
  bonus_rate_7: "อัตรา 7(%)",
  bonus_rate_8: "อัตรา 8(%)",
  bonus_rate_9: "อัตรา 9(%)",
  bonus_rate_10: "อัตรา 10(%)",
  delete_all: "ลบทั้งหมด",
  rescue_fund: "กองทุนกู้ภัย",
  up: "ขึ้น",
  down: "ลง",
  rate_percent: "อัตรา %",
  cycle: "วงจร",
  actual_amount: "จํานวนเงินจริง",
  rounded_amount: "จํานวนเงินที่ถูกปัดเศษ",
  rescue_id: "รหัสกู้ภัย",
  rescue_name: "ชื่อกู้ภัย",
  min_lose: "มินแพ้",
  max_payout: "การจ่ายเงินสูงสุด",
  payout_method: "วิธีการจ่ายเงิน",
  target_group: "กลุ่มเป้าหมาย",
  member_vip_id: "รหัสวีไอพีของสมาชิก",
  daily: "รายวัน",
  weekly: "รายสัปดาห์",
  monthly: "รายเดือน",
  edit_batch: "แก้ไขแบทช์",
  current_level: "ระดับปัจจุบัน",
  next_level: "ระดับต่อไป",
  bet_value: "มูลค่าเดิมพัน",
  line_bet: "ไลน์เดิมพัน",
  total_round: "รอบรวม",
  audit_by: "ตรวจสอบโดย",
  possible_next_level: "ระดับต่อไปที่เป็นไปได้",
  maintain_deposit: "รักษาเงินฝาก",
  maintain_turnover: "รักษาการหมุนเวียน",
  starting_deposit: "เริ่มฝากเงิน",
  starting_turnover: "การเริ่มต้นการหมุนเวียน",
  cycle_deposit: "เงินฝากวงจร",
  cycle_turnover: "หมุนเวียนวงจร",
  vip_list: "รายการวีไอพี",
  up_maintain: "รักษาไว้",
  down_lowest: "ต่ําสุดลง",
  manual: "คู่มือ",
  daily_winlose_game: "เดลี่วินลอส (เกม)",
  actionaff: "การกระทํา (พันธมิตร)",
  onload: "โหลด",
  update_status: "อัปเดตสถานะ",
  role_settings: "การตั้งค่าบทบาท",
  customer_services: "การบริการลูกค้า",
  marketing: "การตลาด",
  finance: "การเงิน",
  payment: "การชําระเงิน",
  risk_management: "การบริหารความเสี่ยง",
  pt: "ปตท.",
  wallet_history: "ประวัติศาสตร์กระเป๋าสตางค์",
  ticket_amount: "จํานวนตั๋ว",
  ignore_risk: "ไม่สนใจความเสี่ยง",
  permitted_amount: "จํานวนเงินที่อนุญาต",
  all_pending_ticket: "ตั๋วที่รอดําเนินการทั้งหมด",
  rescue_fund_summary: "สรุปกองทุนกู้ภัย",
  rescue_fund_summary_daily: "สรุปกองทุนกู้ภัยรายวัน",
  rescue_fund_member: "สมาชิกกองทุนกู้ภัย",
  master: "อาจารย์",
  account_type: "ประเภทบัญชี",
  freeze: "แช่แข็ง",
  domain_member_setup: "การตั้งค่าโดเมนไซต์สมาชิก",
  domain: "โดเมน",
  domain_list: "รายการโดเมน",
  domain_application: "แอปพลิเคชันโดเมน",
  domain_status: "สถานะโดเมน",
  domain_group: "กลุ่มโดเมน",
  operator_id: "รหัสผู้ปฏิบัติงาน",
  domain_type: "ประเภทโดเมน",
  module: "โมดูล",
  template: "เทมเพลต",
  custom: "กําหนดเอง",
  default: "ค่าเริ่มต้น",
  payment_provider: "ผู้ให้บริการชําระเงิน",
  payment: "การชำระเงิน",
  deactivate: "ไม่ได้ใช้งาน",
  name_server: "เนมเซิร์ฟเวอร์",
  server_account: "บัญชีเซิร์ฟเวอร์",
  service_provider: "ผู้ให้บริการ",
  process: "กระบวนการ",
  provider_operator: "ผู้ให้บริการดําเนินการ",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "การตั้งค่าทั่วโลก",
  second_id: "รหัสที่สอง",
  unverified: "ไม่ได้รับการยืนยัน",
  pt_affiliate: "ค่าธรรมเนียมแพลตฟอร์มพันธมิตร (%)",
  recipient_bank: "ธนาคารผู้รับ",
  deposit_type: "ประเภทเงินฝาก",
  security_fund: "กองทุนรักษาความปลอดภัย",
  adjust_balance_op: "ปรับกระเป๋าเงินผู้ประกอบการ",
  adjust_security_deposit_op: "ปรับกองทุนหลักประกันผู้ประกอบการ",
  marquee: "กระโจม",
  marquee_content: "เนื้อหามาร์คี",
  edit_marquee: "แก้ไขมาร์คี",
  domain_available: "โดเมนที่มีอยู่",
  daily_withdrawal_frequency: "ความถี่ในการถอนเงินรายวัน",
  maintenance: "การบํารุงรักษา",
  max_withdrawal: "การถอนสูงสุด",
  min_balance: "ยอดคงเหลือขั้นต่ํา",
  affiliate_report: "รายงานพันธมิตร",
  cash_balance: "ยอดเงินสด",
  copy_success: "คัดลอกสําเร็จ!",
  copy_failed: "คัดลอกล้มเหลว!",
  your_website: "เว็บไซต์ของคุณ",
  correction_promo: "การแก้ไข(การส่งเสริมการขาย)",
  others: "อื่นๆ",
  audit_log: "บันทึกการตรวจสอบ",
  view: "ดู",
  price: "ราคา",
  package_level: "ระดับบรรจุภัณฑ์",
  bo_right: "โบ ถูกต้อง",
  english: "ภาษาอังกฤษ",
  simplified_chinese: "จีน (CN)",
  traditional_chinese: "จีน (TW)",
  philippine: "ฟิลิปปินส์",
  thai: "ไทย",
  vietnamese: "เวียดนาม",
  indonesian: "อินโดนีเซีย",
  myanmar: "เมียนมาร์",
  japanese: "ภาษาญี่ปุ่น",
  korean: "เกาหลี",
  package_type: "ประเภทบรรจุภัณฑ์",
  full_back_office_access_right: "สิทธิ์การเข้าถึงสํานักงานแบบย้อนกลับเต็มรูปแบบ",
  read_only_back_office: "อ่านเฉพาะแบ็คออฟฟิศ",
  language: "ภาษา",
  lang_code: "รหัสภาษา",
  description: "คําอธิบาย",
  provider_type: "ประเภทผู้ให้บริการ",
  logo: "โลโก้",
  theme_provider: "ผู้ให้บริการธีม",
  theme_content: "เนื้อหาธีม",
  content_id: "รหัสเนื้อหา",
  content_desc: "คําอธิบายเนื้อหา",
  theme_content_position: "ตําแหน่งเนื้อหาธีม",
  theme: "ธีม",
  theme_code: "รหัสธีม",
  theme_name: "ชื่อธีม",
  color: "สี",
  position: "ตําแหน่ง",
  site_name: "ชื่อสถานที่",
  theme_color: "สีธีม",
  theme_purchased: "ซื้อธีมแล้ว",
  total_purchased: "ยอดซื้อทั้งหมด",
  purchased_date: "วันที่ซื้อ",
  purchase: "ซื้อ",
  total_site: "ไซต์ทั้งหมด",
  content_setup: "การตั้งค่าเนื้อหา",
  site_list: "รายชื่อเว็บไซต์",
  site_id: "รหัสไซต์",
  draft_version: "ฉบับร่าง",
  prod_version: "ผลิตภัณฑ์ เวอร์ชัน",
  production_version: "เวอร์ชันการผลิต",
  info: "ข้อมูล",
  setting: "การตั้งค่า",
  site_info: "ข้อมูลไซต์",
  menu: "เมนู",
  game_menu: "เมนูเกม",
  special_menu: "เมนูพิเศษ",
  setting_menu: "การตั้งค่าเมนู",
  error: "ข้อผิดพลาด",
  sync_all: "ซิงค์ทั้งหมด",
  theme_content_group: "กลุ่มเนื้อหาธีม",
  content_group: "กลุ่มเนื้อหา",
  content_group_desc: "คําอธิบายกลุ่มเนื้อหา",
  parent_content_id: "รหัสเนื้อหาหลัก",
  bo_default_domain: "โดเมนเริ่มต้นของ BO",
  domain_id: "รหัสโดเมน",
  deactive: "ปิดการใช้งาน",
  site_sync: "การซิงค์ไซต์",
  upload: "อัปโหลด",
  comingSoon: "เร็วๆ นี้",
  profile_setting: "การตั้งค่าโปรไฟล์",
  bank: "ธนาคาร",
  company: "บริษัท",
  own: "ของตัวเอง",
  operator_setting: "การตั้งค่าผู้ปฏิบัติงาน",
  external_id: "รหัสภายนอก",
  ticket: "ตั๋ว",
  bank_owner: "เจ้าของธนาคาร",
  exchanged_currency: "สกุลเงินแลกเปลี่ยน",
  company_bank_owner: "เจ้าของธนาคารบริษัท",
  ticket_list_member: "รายการตั๋ว (สมาชิก)",
  game_name_exclude: "ไม่รวมชื่อเกม",
  tab: "แท็บ",
  about_us: "เกี่ยวกับเรา",
  privacy_policy: "นโยบายความเป็นส่วนตัว",
  responsible_gaming: "การเล่นเกมอย่างมีความรับผิดชอบ",
  banking: "การธนาคาร",
  faqs: "คําถามที่พบบ่อย",
  advertisement: "โฆษณา",
  px_pixel_id: "รหัสพิกเซล PX",
  px_token: "โทเค็น PX",
  af_dev_key: "คีย์ Af Dev",
  af_apps_id: "รหัสแอป Af",
  pp_tid: "พีพี ทิด",
  pp_pid: "พีพีพีไอดี",
  pp_aid: "พีพีเอด",
  gtm_id: "จีทีเอ็มไอดี",
  service_provider_url: "URL ผู้ให้บริการ",
  script_inject: "ฉีดสคริปต์",
  head_script: "สคริปต์หัว",
  body_script: "สคริปต์ร่างกาย",
  ads_id: "รหัสโฆษณา",
  member_detail: "รายละเอียดสมาชิก",
  memberreport: "รายงานสมาชิก",
  member_log: "บันทึกสมาชิก",
  general: "ทั่วไป",
  top_theme: "ธีมยอดนิยม",
  hot_game: "เกมร้อน",
  hot_list: "รายการยอดนิยม",
  new_game: "เกมใหม่",
  popular_game: "เกมยอดนิยม",
  featured_game: "เกมเด่น",
  new_list: "รายการใหม่",
  popular_list: "รายการยอดนิยม",
  featured_list: "รายการเด่น",
  provider_new_game: "ผู้ให้บริการเกมใหม่",
  provider_popular_game: "ผู้ให้บริการเกมยอดนิยม",
  provider_featured_game: "ผู้ให้บริการเกมเด่น",
  website: "เว็บไซต์",
  site_customization: "การปรับแต่งไซต์",
  export_all: "ส่งออกทั้งหมด",
  export_one: "ส่งออก (หน้าปัจจุบัน)",
  daily_ledger: "บัญชีแยกประเภทรายวัน",
  daily_ledger_member: "บัญชีแยกประเภทรายวัน (สมาชิก)",
  promotion_signup_unused: "โปรโมชั่นสมัครสมาชิกที่ไม่ได้ใช้",
  promotion_signup_ongoing: "โปรโมชั่นการสมัครใช้งานอย่างต่อเนื่อง",
  promotion_signup_winlose: "สมัครโปรโมชั่น Winlose",
  promotion_signup_winlose_operator: "โปรโมชั่นการสมัคร Winlose (ผู้ดําเนินการ)",
  promotion_signup_winlose_member: "โปรโมชั่นการสมัคร Winlose (สมาชิก)",
  total_player_balance: "ยอดคงเหลือผู้เล่นทั้งหมด",
  search_all: "ค้นหาทั้งหมด",
  mbsetting: "การตั้งค่า",
  todays_highlights: "ไฮไลท์วันนี้",
  deposit_player: "ผู้เล่นฝากเงิน",
  withdrawal_player: "ผู้เล่นถอนตัว",
  kill_rate: "อัตราการฆ่า",
  login_player: "ผู้เล่นเข้าสู่ระบบ",
  operation_management: "ปฏิบัติการ",
  game_management: "เกม",
  member_management: "สมาชิก",
  affiliate_management: "พันธมิตร",
  promotion_management: "การส่งเสริมการขาย",
  mbcampaign: "แคมเปญ",
  promo_allday: "ทั้งวัน",
  promo_daily: "รายวัน",
  promo_daily_first_deposit: "การฝากเงินครั้งแรกทุกวัน",
  promo_deposit_monthly: "จํานวนเงินฝากรายเดือน",
  promo_deposit_signup: "การลงทะเบียนนับเงินฝาก",
  promo_deposit_weekly: "จํานวนเงินฝากรายสัปดาห์",
  promo_newbie: "มือใหม่",
  promo_once: "ครั้งเดียว",
  dd_review: "รีวิว",
  game_provider_management: "ผู้ให้บริการ",
  exchanged_amount: "จํานวนเงินที่แลกเปลี่ยน",
  operator_summary: "บทสรุปผู้ปฏิบัติงาน",
  business_id: "รหัสธุรกิจ",
  game_name_exclude_log: "ชื่อเกมไม่รวมบันทึก",
  cn: "ซีเอ็น",
  local: "ท้องถิ่น",
  taken: "ถ่ายแล้ว",
  receiver_bank: "ธนาคารผู้รับ",
  receiver_bank_acc_no: "ธนาคารผู้รับ Acc No.",
  receiver_bank_acc_holder: "ผู้ถือ Acc ของธนาคารผู้รับ",
  add_balance: "เพิ่มยอดคงเหลือ",
  deduct_balance: "หักยอดคงเหลือ",
  sync_site_content: "ซิงค์เนื้อหาไซต์",
  payment_setting: "การตั้งค่าการชําระเงิน",
  payment_own: "ของตัวเอง",
  payment_global: "ระดับโลก",
  livechat: "ไลฟ์แชท",
  chat_id: "คีย์ใบอนุญาต LiveChat",
  chat_provider: "ผู้ให้บริการ LiveChat",
  auto_cycle: "รอบ",
  auto_all: "ทั้งหมด",
  completed_amount: "จำนวนที่เสร็จสิ้น",
  website_launched: "เว็บไซต์เปิดใช้งานแล้ว",
  total_operators: "ผู้ให้บริการทั้งหมด",
  today_active: "ผู้ใช้งานวันนี้",
  new_player_verified_signup: "ผู้เล่นใหม่ ยืนยัน/สมัครสมาชิก",
  total_players: "จำนวนผู้เล่นทั้งหมด",
  depo_withdrawal_diff: "ส่วนต่างระหว่างฝาก-ถอน",
  claim_count: "จำนวนการเคลม",
  ggr: "GGR",
  member_balance: "ยอดเงินสมาชิก",
  players: "ผู้เล่น",
  provider_pt: "ผู้ให้บริการ PT",
  base: "ฐาน",
  topup_id: "รหัสเติมเงิน",
  credential: "ข้อมูลรับรอง",
  credential_1: "ข้อมูลรับรอง 1",
  credential_2: "ข้อมูลรับรอง 2",
  credential_3: "ข้อมูลรับรอง 3",
  credential_4: "ข้อมูลรับรอง 4",
  credential_5: "ข้อมูลรับรอง 5",
  credential_6: "ข้อมูลรับรอง 6",
  credential_7: "ข้อมูลรับรอง 7",
  credential_8: "ข้อมูลรับรอง 8",
  credential_9: "ข้อมูลรับรอง 9",
  credential_10: "ข้อมูลรับรอง 10",
  limit: "ขีดจำกัด",
  create: "สร้าง",
  hint: "คำแนะนำ",
  quickSetup: "ตั้งค่าอย่างรวดเร็ว",
  next: "ถัดไป",
  setUpTheme: "ตั้งค่าธีม",
  checkOut: "ตรวจสอบ",
  standardPackage: "แพ็กเกจมาตรฐาน",
  siteName: "ชื่อเว็บไซต์",
  information: "ข้อมูล",
  useThisTemplate: "ใช้เทมเพลตนี้",
  summary: "สรุป",
  createOperatorAccount: "สร้างบัญชีผู้ดูแลระบบ",
  operatorId: "รหัสผู้ดูแลระบบ",
  operatorPwd: "รหัสผ่านผู้ดูแลระบบ",
  new_website: "เว็บไซต์ใหม่",
  operator_information: "ข้อมูลผู้ดำเนินการ",
  bo_link: "ลิงก์ระบบหลังบ้าน",
  daily_summary_sms: "สรุป SMS รายวัน",
  daily_summary_sms_operator: "สรุป SMS รายวันของผู้ให้บริการ",
  daily_summary_sms_operator_detail: "รายละเอียดสรุป SMS รายวันของผู้ให้บริการ",
  sms_count: "จำนวน SMS",
  provider_winlose_operator_pt: "ผู้ให้บริการ Winlose (ผู้ให้บริการ PT)",
  pt_on: "PT คือ",
  share_operator: "แชร์โอเปอเรเตอร์",
  share_company: "ร่วมกัน",
  token_log: "บันทึกโทเค็น",
  template_code: "รหัสแม่แบบ",
  template_name: "ชื่อแม่แบบ",
  mini_game: "มินิเกม",
  max_game_reward: "รางวัลสูงสุดของเกม",
  max_chance_per_day: "โอกาสสูงสุดต่อวัน",
  is_recurring_chance: "เกิดซ้ำ",
  token_request: "โทเค็น",
  enabled: "เปิดใช้งาน",
  disabled: "ปิดใช้งาน",
  unlimited: "ไม่จำกัด",
  max_chance_unlimited: "โอกาสสูงสุดต่อวันไม่จำกัด",
  mini_game_template: "แม่แบบมินิเกม",
  reward_code: "รหัสรางวัล",
  reward_name: "ชื่อรางวัล",
  reward_description: "คำอธิบายรางวัล",
  reward_probability: "ความน่าจะเป็นของรางวัล",
  total_game: "เกมทั้งหมด",
  total_played_mini_game: "จำนวนเกมย่อยที่เล่น",
  total_played_mini_game_detail: "รายละเอียดจำนวนเกมย่อยที่เล่น",
  total_played_mini_game_detail_operator: "รายละเอียดจำนวนเกมย่อยที่เล่น (ผู้ดำเนินการ)",
  daily_pnl_operator: "P&L รายวัน (ผู้ดำเนินการ)",
  token: "โทเคน",
  token_1: "โทเคน 1",
  token_2: "โทเคน 2",
  token_3: "โทเคน 3",
  token_4: "โทเคน 4",
  token_5: "โทเคน 5",
  token_6: "โทเคน 6",
  token_7: "โทเคน 7",
  cash_1: "เงินสด 1",
  cash_2: "เงินสด 2",
  cash_3: "เงินสด 3",
  cash_4: "เงินสด 4",
  cash_5: "เงินสด 5",
  cash_6: "เงินสด 6",
  cash_7: "เงินสด 7",
  daily_login: "เช็กอินรายวัน (เข้าสู่ระบบรายวัน)",
  daily_login_update: "อัปเดตการเข้าสู่ระบบรางวัล",
  game_result_reward: "รางวัลผลเกม",
  current_streak: "สถิติติดต่อกันปัจจุบัน",
  login_streak: "สถิติเข้าระบบติดต่อกัน",
  total_token: "โทเคนทั้งหมด",
  total_mini_game_token_used: "จำนวนโทเคนที่ใช้ในมินิเกมทั้งหมด",
  total_mini_game_token_used_detail: "รายละเอียดจำนวนโทเคนที่ใช้ในมินิเกมทั้งหมด",
  total_mini_game_token_used_detail_operator: "รายละเอียดจำนวนโทเคนที่ใช้ในมินิเกมทั้งหมด (ผู้ดำเนินการ)",
  total_reward: "รางวัลทั้งหมด",
  total_mini_game_reward: "รางวัลมินิเกมทั้งหมด",
  total_mini_game_reward_detail: "รายละเอียดรางวัลมินิเกมทั้งหมด",
  total_mini_game_reward_detail_operator: "รายละเอียดรางวัลมินิเกมทั้งหมด (ผู้ดำเนินการ)",
  token_balance: "ยอดโทเคน",
  free_game_token: "โทเคนเกมฟรี",
  bo_url: "ลิงก์ Backoffice",
  copied: "คัดลอกแล้ว",
  callback: "การเรียกกลับ (Callback)",
  api: "API",
  prefix: "คำนำหน้า",
  delimiter: "ตัวคั่น",
  url_callback_deposit: "URL การเรียกกลับการฝากเงิน",
  url_callback_withdrawal: "URL การเรียกกลับการถอนเงิน",
  url_callback_affiliate: "URL การเรียกกลับพันธมิตร",
  url_api_deposit: "URL การเรียกกลับการฝากเงิน (API)",
  url_api_withdrawal: "URL การเรียกกลับการถอนเงิน (API)",
  url_api_balance: "URL การเรียกกลับยอดคงเหลือ (API)",
  prefix_deposit: "คำนำหน้าการฝากเงิน",
  prefix_withdrawal: "คำนำหน้าการถอนเงิน",
  prefix_affiliate: "คำนำหน้าพันธมิตร",
  prefix_delimiter: "ตัวคั่นคำนำหน้า",
  merchant: "ผู้ค้า",
  app_id: "รหัสแอป",
  secret_key: "รหัสลับ",
  deposit_secret_key: "รหัสลับสำหรับฝากเงิน",
  withdrawal_secret_key: "รหัสลับสำหรับถอนเงิน",
  partners: "พาร์ทเนอร์",
  partner_name: "ชื่อพาร์ทเนอร์",
  win: "ชนะ",
  manifest: "รายการ",
  crop: "ตัด",
  cropImage: "ตัดภาพ",
  api_url : "URL ของ API",
  start_date_time: "วันและเวลาเริ่มต้น",
  end_date_time: "วันและเวลาสิ้นสุด",
  authentication_key: "รหัสการยืนยันตัวตน",
  one_week: "1 สัปดาห์",
  two_week: "2 สัปดาห์",
  one_month: "1 เดือน",
  two_month: "2 เดือน",
  six_month: "6 เดือน",
  edit_promotion_end_date: "แก้ไขวันสิ้นสุดโปรโมชั่น",
  android_app_link: "ลิงก์แอป Android",
  add_android_app_link: "เพิ่มลิงก์แอป Android",
  operator_details: "รายละเอียดผู้ให้บริการ",
  bsb: "BSB",
  payid: "Pay ID",
  cuit: "CUIT",
  merchant_key: "รหัสกุญแจร้านค้า",
  aes_key: "รหัสกุญแจ AES",
  paycode: "รหัสชำระเงิน",
  api_key: "คีย์ API",
  referral: "การแนะนำ",
  minimum_deposit: "เงินฝากขั้นต่ำ",
  minimum_withdrawal: "การถอนขั้นต่ำ",
  maximum_withdrawal: "การถอนสูงสุด"
}